<template>
    <div>
      <CContainer>
        <CRow>
          <CCol sm="12">
            <div class="text-center">
              <label style="margin-top:25%;font-size:x-large" class="text-center">Click button<strong style="font-weight: 700;"> Press Here</strong>for Student B</label>
              <br /><br />
              <CRow style="display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;">
                <CAlert closeButton style="width:30%" color="success" v-if="SuccessAlert ===true" class="mt-2 text-center">Done !</CAlert>
            </CRow>
              <CButton
                color="info"
                class="btn-select-blue-custom"
                @click="InsertTime"
                style="font-size:x-large"
                >Press Here</CButton
              >
           
            </div>
          </CCol>
        </CRow>
      </CContainer>
      
      <img style="max-width:70%;position:fixed;right:0;bottom:0" src="../assets/img/icon/bannerTime.png" />
    </div>
  </template>

<script>
import Vue from "vue";
import _ from "lodash";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderExam.vue";

export default {
  components: {
    Mainlayout,
  },
  data: function () {
    return {
      SuccessAlert: false,
    };
  },
  methods: {
    InsertTime() {
      const formData = new FormData();
      formData.append("StudentType", "Student B");

      return this.$API
        .post(this.$InsertTime, formData)
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.SuccessAlert = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
          }
        });
    },
  },
};
</script>